export const defaultThemeColor = "#FF3366";
